/**
 * Generated by orval v6.26.0 🍺
 * Do not edit manually.
 * 爆版PC&开放平台
 * OpenAPI spec version: 1.0.0
 */
import { axiosInstance } from "../../axiosInstance";
export type PostBaobPcDownloadTaskList200DataListItem = {
  access_mode: string;
  admin_id: string;
  admin_name: string;
  /** 是否可下载 0否 1是 */
  canDown: number;
  /** 导出时间 */
  create_time: string;
  down_status: string;
  down_type: string;
  end_time: string;
  /** 错误信息 */
  error_msg: string;
  /** 文件名称 */
  filename: string;
  /** 文件下载地址 */
  fileurl: string;
  /** 任务id */
  id: string;
  /** 导出进度 (0-100) */
  progress: string;
  start_time: string;
  /** 任务名 */
  title: string;
  /** 数据总数 */
  total_num: string;
};

export type PostBaobPcDownloadTaskList200Data = {
  list: PostBaobPcDownloadTaskList200DataListItem[];
  total: number;
};

export type PostBaobPcDownloadTaskList200 = {
  code: string;
  data: PostBaobPcDownloadTaskList200Data;
  msg: string;
};

export type PostBaobPcDownloadTaskListBody = {
  page?: number;
  page_size?: number;
  supply_id?: number;
  user_id?: number;
};

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary 导出列表
 */
export const postBaobPcDownloadTaskList = (
  postBaobPcDownloadTaskListBody: PostBaobPcDownloadTaskListBody,
  options?: SecondParameter<typeof axiosInstance>,
) => {
  return axiosInstance<PostBaobPcDownloadTaskList200>(
    {
      url: `/baob/pc.DownloadTask/list`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postBaobPcDownloadTaskListBody,
    },
    options,
  );
};

export type PostBaobPcDownloadTaskListResult = NonNullable<
  Awaited<ReturnType<typeof postBaobPcDownloadTaskList>>
>;
